export default {

    /**
     * Get values list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getValue: state => ({task_field_id, task_field_instance_id}) => {

        // Filter values
        let vals = Object.values(state.values).filter((f) => f.task_field_instance_id === task_field_instance_id && f.task_field_id === task_field_id);

        // Return tasks list
        return vals && vals.length ? vals[0].value : false;
    },

    /**
     * Get list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getList: state => (task_field_instance_id) => {

        // Filter values
        return Object.values(state.values).filter((f) => f.task_field_instance_id === task_field_instance_id);
    }
}
